module.exports = "<rkc-progression></rkc-progression> <div class=customer ng-cloak layout=row> <div ng-if=\"c.customer && c.customer.length === 0\" flex layout=row> <span flex=30></span> <div layout=row flex> <div class=\"circle md-whiteframe-z2\" layout=row layout-align=\"center center\"> <h3 class=white-text>Ingen kunder</h3> </div> </div> </div> <md-card flex ng-show=\"c.tableDefinition.promise || c.customer.length > 0\"> <rkc-table table-definition=c.tableDefinition table-content=c.customer></rkc-table> </md-card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/distribution/customer/customer.html
 ** module id = 496
 ** module chunks = 0
 **/